
import React from 'react';

// Placeholder Icons (Replace with Lucide-React or another library for production)
const FacebookIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>);
const TwitterIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18.4 11.6 2.2.1 4.4-.6 6.5-1.7 4.5-2.5 7.1-7.8 6.4-13.4-1.6 2-3.8 3.5-6.2 4.4 2.8-2.6 4.6-6.2 4.1-10.1-.5.9-1.2 1.7-2 2.3 2.5-.5 4.8-1.7 6.7-3.2-.2 1.2-.8 2.3-1.6 3.2 2-.3 3.9-.7 5.7-1.4z"></path></svg>);
const LinkedinIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>);
const InstagramIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>);

// Define your link arrays for cleaner JSX
const mainLinks = [
  { name: 'Home', href: '/' },
  { name: 'About Us', href: '/about' },
  { name: 'Our Coffee', href: '/coffee' },
  { name: 'Value Addition', href: '/value' },
  { name: 'Sustainability', href: '/sustainability' },
  { name: 'Contact', href: '/contact' },
];

const corporateLinks = [
  { name: 'Global Presence', href: '/global-presence' },
  { name: 'Projects & Partnerships', href: '/projects-partnerships' },
  { name: 'Lot Sheets', href: '/coffee' },
  { name: 'Traceability', href: '/sustainability' },
  { name: 'Quality Standards', href: '/value' },
];

const policyLinks = [
  { name: 'Privacy Policy', href: '/privacy' },
  { name: 'Terms of Service', href: '/terms' },
];

const socialLinks = [
    { icon: <FacebookIcon />, href: 'https://facebook.com/funzocoffee', name: 'Facebook' },
    { icon: <TwitterIcon />, href: 'https://twitter.com/funzocoffee', name: 'Twitter' },
    { icon: <LinkedinIcon />, href: 'https://linkedin.com/company/funzocoffee', name: 'LinkedIn' },
    { icon: <InstagramIcon />, href: 'https://instagram.com/funzocoffee', name: 'Instagram' },
];


function Footer() {
  return (
    <footer className="bg-coffee-primary text-coffee-light pt-16 pb-0 text-base leading-relaxed">
      <div className="max-w-6xl mx-auto px-6 pb-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        
        {/* 1. Brand & Description Column (Left Aligned) */}
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-3 mb-2">
            <img src="/logo/FUNZOLOGOwhite.jpg" alt="Funzo Coffee Logo" className="w-16 h-16 "/>
            <span className="font-bold text-white text-xl">Funzo Coffee Limited</span>
          </div>
          <p className="text-coffee-light mb-4 text-base">
            Ugandan coffee, refined through Mafunzo—lessons that shape quality and community.
          </p>
          <div className="flex gap-4 mt-2" aria-label="Social Media Links">
            {socialLinks.map((link) => (
                <a 
                    key={link.name} 
                    href={link.href} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="text-coffee-light transition-colors duration-200 hover:text-coffee-accent"
                    aria-label={link.name}
                >
                    {link.icon}
                </a>
            ))}
          </div>
        </div>

        {/* 2. Navigation Link Columns */}
        <div className="flex flex-col gap-3">
          <span className="text-white font-bold text-lg mb-2 tracking-wide">Company</span>
          {mainLinks.map((link) => (
            <a key={link.name} href={link.href} className="text-coffee-light text-base py-1 transition-all duration-200 hover:text-coffee-accent hover:pl-1">{link.name}</a>
          ))}
        </div>
        
        <div className="flex flex-col gap-3">
          <span className="text-white font-bold text-lg mb-2 tracking-wide">Resources</span>
          {corporateLinks.map((link) => (
            <a key={link.name} href={link.href} className="text-coffee-light text-base py-1 transition-all duration-200 hover:text-coffee-accent hover:pl-1">{link.name}</a>
          ))}
        </div>

        {/* 3. Newsletter/CTA Column (Right Aligned) */}
        <div className="flex flex-col gap-3">
          <span className="text-white font-bold text-lg mb-2 tracking-wide">Get Updates</span>
          <p className="text-base mb-4">
            Subscribe to our newsletter for the latest insights on coffee markets and sustainability.
          </p>
          <form onSubmit={(e) => {
            e.preventDefault();
            const email = e.target.elements['newsletter-email-modern'].value;
            const mailtoLink = `mailto:info@funzocoffee.com?subject=${encodeURIComponent('Newsletter Subscription')}&body=${encodeURIComponent(`Please subscribe me to the newsletter.\n\nEmail: ${email}`)}`;
            window.location.href = mailtoLink;
            e.target.reset(); // Clear the form
          }} aria-label="Newsletter subscription" className="flex flex-col gap-2">
            <label htmlFor="newsletter-email-modern" className="sr-only">Email Address</label>
            <input 
              type="email" 
              id="newsletter-email-modern" 
              placeholder="name@example.com" 
              aria-label="Email Address for newsletter" 
              required
              className="p-3 border border-coffee-light rounded-md bg-transparent text-white text-base placeholder-gray-400 focus:outline-none focus:ring-1 focus:ring-coffee-accent"
            />
            <button type="submit" className="bg-coffee-accent text-coffee-dark font-semibold p-3 rounded-md cursor-pointer transition-colors duration-200 hover:bg-orange-400">Subscribe</button>
          </form>
        </div>
      </div>

      {/* Footer Bottom Bar */}
      <div className="border-t border-white/10 mt-12 py-6">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center text-sm">
          <span className="text-coffee-light">© {new Date().getFullYear()} Funzo Coffee Limited. All rights reserved.</span>
          <div className="flex gap-6 mt-4 md:mt-0">
            {policyLinks.map((link) => (
                <a key={link.name} href={link.href} className="text-coffee-light text-base transition-colors duration-200 hover:text-coffee-accent">{link.name}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
